<template>
    <div>
        <!-- <b-card no-body v-if="perfilGestor">
            <b-card-body>
                <h5 class="heading-1 mb-4">
                    <span
                        >PRAZOS PARA SOLICITAÇÕES DE ADITIVOS DAS
                        ETAPAS</span
                    >
                </h5>
                <pnl-vencimentos-etapas
                    :pnlVencimentos="pnlVencimentos"
                    v-if="perfilGestor"
                    @filtrarPorPeriodo="$emit('filtrarPorPeriodo', $event)"
                >
                </pnl-vencimentos-etapas>
            </b-card-body>
        </b-card> -->
        <b-card no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>PROJETOS SGTEC</span>
                </h4>
                <projetos-filtros
                    :projetos="projetos"
                    :servicos="servicos"
                    @atualizarFiltro="atualizarFiltro($event)"
                ></projetos-filtros>
                <app-tabela
                    idTabela="tblProjetos"
                    :itens="projetos"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="botoes">
                        <slot name="botoes"></slot>
                    </template>
                    <template slot="valorTotal" slot-scope="data"
                        >{{ data.valorTotal | currency }}
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <slot name="acoes" v-bind="data"></slot>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import ProjetosFiltros from './ProjetosFiltros';

export default {
    methods: {
        atualizarFiltro(filtro) {
            this.$emit('atualizarFiltro', filtro)
        },
    },

    computed: {
        perfilGestor() {
            return (
                this.$route.name == 'Sgtec_Gestores_Projetos' 
            )
        }
    },

    props: {
        projetos: {
            type: Array,
            default: () => []
        },

        pnlVencimentos: {
            type: Object
        },

        servicos: {
            type: Object
        }
    },

    components: {
        ProjetosFiltros,
       
    },

    data() {
        return {
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'codProjeto',
                    label: 'Código',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'projeto',
                    label: 'Projeto',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'unidade',
                    label: 'Unidade',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'gestor',
                    label: 'Gestor',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'credenciado',
                    label: 'Fornecedor',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'fichaTecnica',
                    label: 'Ficha Técnica',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'qtdEtapas',
                    label: 'Etapas',
                    tdClass: 'text-center'
                },
                {
                    key: 'totalHoras',
                    label: 'Total Horas',
                    tdClass: 'text-center'
                },
                {
                    key: 'valorTotal',
                    label: 'Valor Total',
                    tdClass: 'text-nowrap text-right'
                }
            ],
            itensPorPagina: 5
        }
    }
}
</script>
